<template>
  <div :style="maxHeight" @mousewheel="getMaxHeight" style="overflow: hidden;">
  <div  style="width: 100%;height: 50px;">
    <el-form :model="formData" label-width="20px">
      <el-row>
        <el-form-item label="">
          <el-select v-model="formData.wujianId" placeholder="物件番号" class="toolbar_item" style="width: 200px" clearable>
            <el-option v-for="dict in wujianNameLlist" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formData.stockType" :placeholder="$t('makeSchedule.mfgMaterialConfirm.stockType')" class="toolbar_item" style="width: 100px"
                     clearable>
            <el-option v-for="dict in stockTypeList" :key="dict.id" :label="dict.label" :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formData.modelType" :placeholder="$t('makeSchedule.mfgMaterialConfirm.modelType')" class="toolbar_item" style="width: 100px"
                     clearable>
            <el-option v-for="dict in modelTypeList" :key="dict.id" :label="dict.label" :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="formData.checkMaterialShortage" :label="$t('makeSchedule.mfgMaterialConfirm.onlyDisplayShortageInventory')"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selectMaterialData" :loading="selectMaterialLoading">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="saveSort" :loading="sortLoading">保存</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" style="width: 80px" :loading="exportLoading" @click="exportMaterialConfirm">导出</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <div style="width: 100%;height: 90%;">
    <el-table :data="materialData" :key="tableKey" stripe style="width: 100%" :header-cell-style="{textAlign: 'center'}"
              :cell-style="{ textAlign: 'center', width: '100%',}" height="100%">
      <el-table-column :label="this.wujianId+'-'+this.wujianName" width="150" fixed>
        <el-table-column label="物料信息" width="150" fixed>
          <el-table-column prop="type" label="类型" width="80" fixed/>
          <el-table-column prop="cInvCode" :label="$t('makeSchedule.mfgMaterialConfirm.inventoryCode')" width="120" fixed/>
          <el-table-column prop="name" :label="$t('makeSchedule.mfgMaterialConfirm.inventoryName')" width="200" fixed/>
        </el-table-column>
      </el-table-column>

      <el-table-column v-for="item in batchList" :key="item.idx" >
        <template v-slot:header>
          <span> {{ item.idx }}</span>
          <el-button style="margin-left: 30px;" type="primary" link @click="moveSort(item)">←→</el-button>
        </template>
        <el-table-column :label="item.batch_no_describe ">
          <el-table-column width="130">
            <template v-slot:header>
              <el-row>
              <span  :style="{color:item.is_material_shortage ? 'lightcoral' : '#4b8de4' }">{{ item.batch_no }}/{{item.floor}}F</span>
                <div @click="editBatchRemark(item.batch_no)" class="iconClass"><el-icon><ElIconMoreFilled /></el-icon></div>
              </el-row>
            </template>
            <template v-slot="scope">
              <div v-for="lotAll in scope.row.lotList" :key="lotAll.lot">
                <div v-if="item.batch_no == lotAll.lot_no &&  lotAll.lackLot != '' && lotAll.lotNum == Math.abs(lotAll.lackLot)" :style="{background:'lightcoral',color: 'white'}">
                  {{ lotAll.lotNum}}({{lotAll.lackLot}})
                </div>
                <div v-if="item.batch_no == lotAll.lot_no &&  lotAll.lackLot != '' && lotAll.lotNum > Math.abs(lotAll.lackLot)" :style="{background:'#FFFF0080'}">
                  {{ lotAll.lotNum}}({{lotAll.lackLot}})
                </div>
                <div v-if="item.batch_no == lotAll.lot_no && lotAll.lackLot == ''">
                  {{ lotAll.lotNum}}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>


      <el-table-column label="物料数据">
        <el-table-column prop="totalLotNum" :label="$t('makeSchedule.mfgMaterialConfirm.total')" width="80"/>
        <el-table-column prop="totalInventoryNum" :label="库存" width="80"/>
        <el-table-column prop="glassPoorNum" label="玻璃不良" width="80"/>
        <el-table-column prop="materialShortage" label="缺料" width="80">
          <template v-slot="scope">
            <div :style="{color: scope.row.materialShortage < '0' ? 'lightcoral' : 'black',}">
              {{ scope.row.materialShortage }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="150"/>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template #default="scope">
          <el-button type="primary" link @click="editRemarks(scope.row)">备注</el-button>
          <el-button type="primary" link @click="wujianPlan(scope.row)">计划</el-button>
        </template>
      </el-table-column>

    </el-table>
  </div>
  </div>
  <el-dialog title="列设置" v-model="dialogUpdateColumn" width="30%">
    <el-form label-width="50px" >
      <el-form-item>
        <spna style="font-size: 18px">将第</spna>
        <spna style="color: red;font-size: 18px"> {{ "【" + oldColumns + "】" }}</spna>
        <spna style="font-size: 18px"> 列移至：第
          <el-input-number v-model="newColumn" :min="1"/>
          列
        </spna>
      </el-form-item>
      <el-form-item label-width="160px">
        <el-button @click="dialogUpdateColumn = false" plain type="primary">取消</el-button>
        <el-button @click="sortDetermine" type="primary" :loading ="sortLoading">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <el-dialog title="物料备注" v-model="dialogEditRemarks" width="30%">
    <el-form :model="formData" label-width="100px">
      <el-form-item :label="$t('makeSchedule.mfgMaterialConfirm.type')" prop="star">{{ formData.type }}</el-form-item>
      <el-form-item :label="$t('makeSchedule.mfgMaterialConfirm.inventoryCode')" prop="star">{{ formData.cInvCode }}</el-form-item>
      <el-form-item :label="$t('makeSchedule.mfgMaterialConfirm.inventoryName')" prop="star">{{ formData.name }}</el-form-item>
      <el-form-item label="物料备注" prop="star">
        <el-input v-model="formData.remark" style="width: 250px" type="textarea" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="editDetermine(this.formData)" type="primary">确定</el-button>
      </el-form-item>
      <div>
        <el-table :data="materialRemarkData" stripe border :header-cell-style="{textAlign: 'center'}"
                  :cell-style="{ textAlign: 'center', width: '100%',}">
          <el-table-column prop="index" label="序号" width="80" fixed>
            <template v-slot="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="编辑时间" />
          <el-table-column prop="remark" label="备注" />
        </el-table>
      </div>
    </el-form>
  </el-dialog>

  <el-dialog title="批号备注" v-model="dialogBatchRemarks" width="30%">
    <el-form :model="batchData" label-width="100px">
      <el-form-item label="物件：" prop="star">{{ batchData.wujian_id }}</el-form-item>
      <el-form-item label="批号：" prop="star">{{ batchData.batch_no }}</el-form-item>
      <el-form-item label="批号备注：" prop="star">
        <el-input v-model="batchData.remark" style="width: 250px" type="textarea" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="batchDetermine(this.batchData)" type="primary">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <el-dialog title="物料计划" v-model="dialogWujianPlan" width="50%">
    <el-form :model="formData" label-width="120px">
      <el-row>
        <el-form-item :label="$t('makeSchedule.mfgMaterialConfirm.stockType')">
          <el-input v-model="formData.type" disabled ></el-input>
        </el-form-item>
        <el-form-item label="库存数量" label-width="250px" >
          <el-input v-model="formData.totalInventoryNum" disabled ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item :label="$t('makeSchedule.mfgMaterialConfirm.inventoryCode')" >
          <el-input v-model="formData.cInvCode" disabled ></el-input>
        </el-form-item>
        <el-form-item :label="$t('makeSchedule.mfgMaterialConfirm.plannedDeliveryQuantity')"  label-width="250px" >
          <el-input v-model="formData.planArrivalNum" disabled ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item :label="$t('makeSchedule.mfgMaterialConfirm.inventoryName')">
          <el-input v-model="formData.name" disabled ></el-input>
        </el-form-item>

        <el-form-item v-if="formData.materialShortage < 0" label="计划缺料数量"  label-width="250px" >
          <el-input v-model="formData.materialShortage" disabled ></el-input>
        </el-form-item>
      </el-row>
        <el-table :data="wujianPlanData" stripe border :header-cell-style="{textAlign: 'center'}"
                  :cell-style="{ textAlign: 'center', width: '100%',}">
          <el-table-column prop="index" label="序号" width="80" fixed>
            <template v-slot="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="cPOID" :label="$t('makeSchedule.mfgMaterialConfirm.orderNo')" />
          <el-table-column prop="iQuantity" label="数量"/>
          <el-table-column prop="dArriveDate" :label="$t('makeSchedule.mfgMaterialConfirm.orderArrivalDate')" />
          <el-table-column prop="address" :label="$t('makeSchedule.mfgMaterialConfirm.latestEstimatedDate')" />
          <el-table-column prop="remark" label="备注" />
        </el-table>
    </el-form>
  </el-dialog>

  <el-dialog width="30%" title="提示" :show-close="false" :close-on-click-modal=false  v-model="confirmSaveSort" draggable>
    <span style="font-size: 20px">【{{this.wujianId}}】物件进行了排序，您是否保存？</span>
    <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
      <el-button type="primary"  @click="cancel">取消</el-button>
      <el-button type="success"  :loading="sortLoading" @click="saveSort">保存</el-button>
    </div>
  </el-dialog>

</template>

<script>

export default {
  name: "MfgMaterialConfirm",
  data() {
    return {
      dialogBatchRemarks:false,
      selectMaterialLoading:false,
      dialogUpdateColumn: false,
      dialogEditRemarks: false,
      dialogWujianPlan:false,
      sortLoading:false,
      exportLoading:false,
      isSave:false,
      confirmSaveSort: false,
      oldColumns: '',
      newColumn: '',
      wujianId: '',
      wujianName:'',
      batchData:{
        wujian_id:'',
        batch_no:'',
        remark: '',
      },
      formData: {
        wujianId: '',
        stockType: '',
        modelType:'',
        type: '',
        cInvCode: '',
        name: '',
        planArrivalNum:'',
        checkMaterialShortage:'',
        totalInventoryNum:'',
        materialShortage:'',
        remark: '',
      },
      maxHeight:'',
      wujianPlanData:[],
      wujianNameLlist: [],
      stockTypeList: [{id: '玻璃', label: '玻璃'}, {id: '部品', label: '部品'}],
      modelTypeList: [{id: 'ME', label: 'ME'}, {id: 'MF', label: 'MF'},{id: 'MG', label: 'MG'}],
      materialData: [],
      batchList: [],
      materialRemarkData:[]
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 100;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    //批号备注
    editBatchRemark(item){
      this.dialogBatchRemarks = true;
      this.batchData.wujian_id = this.formData.wujianId
      this.batchData.batch_no = item
      this.$axios.post('mfg/materialConfirm/selectBatchRemarks',this.batchData).then(response => {
        let res = response.data
        this.batchData = res.data
      }, error => {
        this.$message.error(`查询失败` + error.message);
      })
    },
    //确认编辑批号
    batchDetermine(item){
      this.$axios.post('mfg/materialConfirm/editBatchRemarks',item).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.dialogBatchRemarks = false
           return this.$message.success("编辑成功");
        }
      }, error => {
        this.$message.error(`编辑失败` + error.message);
      })
    },
    //移动排序
    moveSort(item) {
      this.dialogUpdateColumn = true;
      this.oldColumns = item.idx;
    },
    //确认排序顺序
    sortDetermine() {

      if (this.newColumn > this.oldColumns) {
        let upData = this.batchList[this.oldColumns - 1];
        this.batchList.forEach((item, index) => {

          if (this.oldColumns < item.idx && item.idx <= this.newColumn) {
            item.idx = index
          }

        });
        this.batchList.splice(this.oldColumns - 1, 1);
        upData.idx = this.newColumn;
        this.batchList.splice(this.newColumn - 1, 0, upData);
      }
      if (this.newColumn < this.oldColumns) {
        let newData = this.batchList[this.oldColumns - 1];
        this.batchList.forEach((item, index) => {

          if (this.newColumn <= item.idx && item.idx < this.oldColumns) {
            item.idx = index + 2
          }

        });
        this.batchList.splice(this.oldColumns - 1, 1);
        newData.idx = this.newColumn;
        this.batchList.splice(this.newColumn - 1, 0, newData);
      }
      this.selectData()
      this.tableKey = Math.random()
      this.dialogUpdateColumn = false;
      this.newColumn = 1
      this.isSave = true
      //添加缓存
      localStorage.setItem('isSave', this.isSave);
      localStorage.setItem('wujianId',this.wujianId)

    },
    //保存
    saveSort(){
      this.sortLoading = true
      let saveSortDate = {materialData : this.materialData,batchList : this.batchList,wujianId: this.wujianId}
      //保存排序
      this.$axios.post('mfg/materialConfirm/saveSort',saveSortDate).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.$message.success("保存成功");
          this.sortLoading = false
          this.selectData()
          this.tableKey = Math.random()
          this.confirmSaveSort = false
          //删除缓存
          localStorage.removeItem("isSave")
          localStorage.removeItem("wujianId")
        }
      }, error => {
        this.$message.error(`保存失败` + error.message);
      })
    },
    //取消保存
    cancel(){
      this.confirmSaveSort = false
      //删除缓存
      localStorage.removeItem("isSave")
      localStorage.removeItem("wujianId")
    },
    //备注编辑
    editRemarks(row) {
      this.dialogEditRemarks = true;
      this.formData.cInvCode = row.cInvCode
      this.formData.name = row.name
      this.formData.type = row.type
      this.formData.remark = row.remark
      this.formData.materialShortage = row.materialShortage
      this.formData.totalLotNum = row.totalLotNum
      this.formData.totalInventoryNum = row.totalInventoryNum
      this.formData.lotList = row.lotList

      this.$axios.post('mfg/materialConfirm/selectMaterialRemarks',row.cInvCode).then(response => {
        let res = response.data
        this.materialRemarkData = res.data
      }, error => {
        this.$message.error(`查询失败` + error.message);
      })
    },
    editDetermine(item){
      this.$axios.post('mfg/materialConfirm/addRemarks',item).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.dialogEditRemarks = false;
          this.selectMaterialData()
          return this.$message.success("编辑成功");

        }
      }, error => {
        this.$message.error(`编辑失败` + error.message);
      })
    },
    //物件计划
    wujianPlan(row) {
      this.dialogWujianPlan = true;
      this.formData.cInvCode = row.cInvCode
      this.formData.type = row.type
      this.formData.name = row.name
      this.formData.totalInventoryNum = row.totalInventoryNum
      this.formData.materialShortage = row.materialShortage
      this.$axios.post('mfg/materialConfirm/getWujianPlanData',row.cInvCode).then(response => {
        let res = response.data
        this.formData.planArrivalNum = res.data.planArrivalNum
        this.wujianPlanData = res.data.procureList

      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })

    },
    //移动顺序判断批号是否缺料
    selectData() {
      this.batchList.forEach((date) => {
        date.is_material_shortage = false
      })
      this.materialData.forEach((item) => {
        let inventoryNum = item.totalInventoryNum
        this.batchList.forEach((batchNoDate) => {
          item.lotList.forEach((lotDate) => {
            if (lotDate.lot_no == batchNoDate.batch_no) {
              inventoryNum = inventoryNum - lotDate.lotNum
              if (!Number.isInteger(inventoryNum)){
                inventoryNum = parseFloat(inventoryNum).toFixed(2);
              }
              if (inventoryNum < 0) {
                lotDate.lackLot = inventoryNum
                batchNoDate.is_material_shortage = true
                inventoryNum = 0
              } else {
                lotDate.lackLot = ''
              }
            }
          })
        })
      });
    },

    //获取物件名称
    getAllWujianName() {
      this.$axios.post('mfg/materialConfirm/getAllWujianName',).then(response => {
        let res = response.data
        this.wujianNameLlist = res.data

      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    //获取物件信息
    selectMaterialData() {
      if (!this.formData.wujianId) {
        return this.$message.error('请先选择物件番号')
      }
      //获取缓存进行比较
      if (localStorage.getItem('wujianId') != this.formData.wujianId && localStorage.getItem('isSave')){
        return this.confirmSaveSort = true;
      }
      if (localStorage.getItem('wujianId') == this.formData.wujianId && localStorage.getItem('isSave')){
        return this.confirmSaveSort = true;
      }
      this.selectMaterialLoading = true
      this.$axios.post('mfg/materialConfirm/getMaterialData',this.formData).then(response => {
        let res = response.data
        this.wujianId = res.data.wujianId
        this.wujianName = res.data.wujianName
        this.batchList = res.data.batchList
        this.materialData = res.data.isNotStockList

        this.selectMaterialLoading = false
        this.selectData()
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    //导出
    exportMaterialConfirm() {
      this.exportLoading = true;
      let materialData = {materialDataList : this.materialData,batchList :this.batchList}
      this.$axios.post('mfg/materialConfirm/exportMaterialConfirm', materialData).then(response => {
        this.exportLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("导出失败" + res.message);
        }

        console.log("res:==", res)
        const url = res.data.data.url;
        const originalName = res.data.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
        return this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //查询是否要保存
    checkSaveStatus() {

      if (localStorage.getItem('isSave')) {
        let saveSortDate = {materialData : this.materialData,batchList : this.batchList,wujianId: this.wujianId}

        let windowObj = {}
        windowObj.icon = "system/view";
        windowObj.component = "bus/make_schedule/MfgMaterialConfirmPrompt";
        windowObj.name = '提示';
        windowObj.parentData = saveSortDate;
        windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
        windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
        windowObj.no_min = true
        windowObj.max = true

        this.$store.dispatch('core/openWindow', windowObj)
        //删除缓存
        localStorage.removeItem("isSave")
        localStorage.removeItem("wujianId")
      }
    },
  },

  mounted() {},
  created() {
    this.getMaxHeight()
    this.getAllWujianName()
  },
  beforeUnmount(){
    this.checkSaveStatus()
  },
}
</script>

<style scoped>

.iconClass {
  width:30px;
  position:absolute;
  font-size: 18px;
  right:0px;
}

.el-table :deep(.cell){
  padding: 0px;
}
.el-table :deep(.el-table__cell) {
  padding: 1px;
}


</style>